/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TenantConfig = {
  properties: {
    tenantId: {
      type: 'string',
      isRequired: true,
    },
    tenantOnboardingApiConfig: {
      type: 'string',
      isRequired: true,
    },
    additionalProperties: {
      properties: {
      },
      isRequired: true,
    },
  },
} as const;
